<template>
  <div class="vzan-address-editor">
    <van-popup
      class="vzan-address-editor-popup"
      id="vzanAddressPopup"
      v-model="$attrs.show"
      round
      position="bottom"
      @click-overlay="handleClose"
    >
      <div class="vzan-address-editor-header" id="vzanAddressHeader">
        <span>编辑收货地址</span>
        <img
          class="close-button"
          src="../vzan-address-editor/img/close.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <div class="vzan-address-editor-container">
        <van-address-edit
          :tel-maxlength="11"
          :address-info="detail"
          :area-list="areaList"
          :show-postal="false"
          :show-delete="false"
          :show-set-default="false"
          :show-search-result="false"
          :area-columns-placeholder="['请选择', '请选择', '请选择']"
          :validator="validate"
          :detail-maxlength="50"
          @save="save_address"
        >
        </van-address-edit>
      </div>
      <div class="vzan-address-editor-footer">
        <van-button
          :class="['editor-button', ...subButtonClass]"
          round
          light
          @click="handleNegative"
          >{{ this.addressId ? '删除' : '取消' }}</van-button
        >
        <van-button
          :class="['editor-button', ...mainButtonClass]"
          round
          @click="handleSave"
          >保存</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'
import $api from '../vzan-address-editor/api'
export default {
  name: 'VzanAddressEditor',
  model: {
    prop: 'show',
    event: 'show'
  },
  props: {
    addressId: Number,
    color: {
      // 主题色
      type: String,
      default: '#f40000'
    },
    subButtonClass: {
      // 副按钮样式名
      type: Array,
      default() {
        return []
      }
    },
    mainButtonClass: {
      // 主按钮样式名
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      areaList,
      detail: {}
    }
  },
  watch: {
    '$attrs.show': {
      handler(show) {
        show && this.init()
      }
    }
  },
  methods: {
    init() {
      this.detail = {}
      this.addressId && this.address()
    },
    handleClose() {
      this.$emit('show', false)
      this.$emit('close')
    },
    handleNegative() {
      this.addressId ? this.del_address() : this.handleClose()
    },
    handleSave() {
      document
        .getElementsByClassName('van-address-edit__buttons')[0]
        .children[0]['click']()
    },
    validate(key, val) {
      if (key === 'name' && val.length > 16) {
        return '收货人姓名不超过16个字'
      }
    },
    async address() {
      try {
        const res = await $api.address({ id: this.addressId })
        this.detail = res.dataObj
          ? {
              id: res.dataObj.id,
              name: res.dataObj.userName,
              tel: res.dataObj.telNumber,
              province: res.dataObj.provinceName,
              city: res.dataObj.cityName,
              county: res.dataObj.townName,
              addressDetail: res.dataObj.detailInfo,
              areaCode: res.dataObj.cityCode,
              isDefault: res.dataObj.isDefault
            }
          : {}
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '获取地址异常')
      }
    },
    async del_address() {
      await this.$dialog.confirm({ message: '确定删除该收货地址吗' })
      try {
        const res = await $api.del_address({ id: this.addressId })
        this.$toast(res.msg || '已移除')
        this.handleClose()
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '删除地址异常')
      }
    },
    async save_address(detail) {
      try {
        const res = await $api.save_address({
          Id: detail.id,
          UserName: detail.name,
          TelNumber: detail.tel,
          DetailInfo: detail.addressDetail,
          ProvinceName: detail.province,
          CityName: detail.city,
          TownName: detail.county,
          CityCode: detail.areaCode,
          IsDefault: detail.isDefault
        })
        this.$toast(res.msg || '保存成功')
        this.handleClose()
      } catch (error) {
        this.$toast(typeof error === 'string' ? error : '保存地址异常')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vzan-address-editor-popup {
  background: #f5f7fa;
  ::v-deep {
    .van-address-edit__buttons {
      display: none;
    }
    .van-address-edit {
      padding: 0;
    }
  }
}
.editor-button {
  flex: 1;
  border: 0;
  font-size: var(--set-font-size14);
  &:not(:last-of-type) {
    margin-right: 12px;
  }
}
.address-button-main {
  background: #f40000;
  color: #ffffff;
}
.address-button-sub {
  background: #fff1f0;
  color: #f40000;
}
.vzan-address-editor-header {
  box-sizing: border-box;
  padding: 16px 0;
  font-size: var(--set-font-size16);
  font-weight: 500;
  color: #202124;
  line-height: 23px;
  text-align: center;
  background: #ffffff;
  position: relative;
  .close-button {
    position: absolute;
    top: 50%;
    right: 12px;
    font-size: var(--set-font-size20);
    color: #dddfe5;
    transform: translateY(-50%);
    width: 23px;
    height: 23px;
    &:active {
      opacity: 0.5;
    }
  }
}
.vzan-address-editor-container {
  box-sizing: border-box;
  padding: 12px 16px;
  height: calc(100% - 55px);
  overflow: hidden auto;
  ::v-deep .van-switch--on {
    background-color: #f5222d;
  }
  ::v-deep .van-cell {
    font-size: var(--set-font-size14);
  }
}
.vzan-address-editor-footer {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
